import { render, staticRenderFns } from "./OesSchoolFinder.vue?vue&type=template&id=27bb8fcc&scoped=true&"
import script from "./OesSchoolFinder.vue?vue&type=script&lang=js&"
export * from "./OesSchoolFinder.vue?vue&type=script&lang=js&"
import style0 from "./OesSchoolFinder.vue?vue&type=style&index=0&id=27bb8fcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb8fcc",
  null
  
)

export default component.exports